import api from '../api';

const chatService = {
    // Conversations
    getConversations: (page = 1) => {
        return api.get(`/talk/conversations?page=${page}`);
    },

    createConversation: (data) => {
        // Support both direct and team conversation creation
        if (data.type === 'direct') {
            return api.post(`/talk/direct`, {
                user_id: data.user_id
            });
        } else if (data.type === 'team') {
            return api.post(`/talk/team`, {
                team_id: data.team_id
            });
        } else {
            // Fallback for generic creation
            return api.post(`/talk/conversations`, data);
        }
    },

    getConversation: (id) => {
        return api.get(`/talk/conversations/${id}`);
    },

    addMembers: (conversationId, userIds) => {
        return api.post(`/talk/conversations/${conversationId}/members`, { user_ids: userIds });
    },

    markAsRead: (id) => {
        return api.post(`/talk/conversations/${id}/read`);
    },

    getAttachmentOnlyOfficeConfig: (conversationId, messageId, uploadId) => {
        return api.get(`/talk/conversations/${conversationId}/messages/${messageId}/attachments/${uploadId}/onlyoffice-config`);
    },

    // Messages
    getDeletionOptions: messageId => api.get(`/talk/messages/${messageId}/deletion-options`),
    editMessage: (messageId, body) => api.patch(`/talk/messages/${messageId}`, { body }),
    deleteMessage: (messageId, scope) => api.delete(`/talk/messages/${messageId}`, { data: { scope } }),
    forwardMessage: (messageId, conversationId) => api.post(`/talk/messages/${messageId}/forward`, { conversation_id: conversationId }),

    getMessages: (conversationId, page = 1) => {
        return api.get(`/talk/conversations/${conversationId}/messages?page=${page}`);
    },

    sendMessage: (conversationId, data) => {
        // Send JSON data with temp_upload_ids (files already uploaded)
        return api.post(`/talk/conversations/${conversationId}/messages`, data);
    },

    // Temp uploads
    uploadTempFile: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return api.post('/temp-upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });
    },

    // Teams/Users Search (for starting chats)
    searchUsers: (query, page = 1) => {
        return api.get(`/users/search?query=${encodeURIComponent(query)}&page=${page}`);
    },

    searchTeams: (query, page = 1) => {
        return api.get(`/v1/teams/search?q=${encodeURIComponent(query)}&page=${page}`);
    }
};

export default chatService;
